import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontMap } from "./defaults";
import { UnsetButton } from "../buttons";
import { FlexColContainer } from "../layout";

export const FontOptionsWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  width: 300px;
  flex-wrap: wrap;
`;

const StyledFontOption = styled(UnsetButton)<{ selected?: boolean }>(
  ({ selected }) => ({
    width: "89px",
    height: "69px",
    boxShadow: selected
      ? `0 -6px 12px -2px inset rgba(255, 255, 255, 1),
        0 0 0 0.5px inset rgba(237, 236, 229, 1),
        0 0 4px 2px inset rgba(186, 183, 168, 1)`
      : `0 1px 4px 0 rgba(9, 9, 11, 0.08),
        0 -17px 10px -1px inset rgba(250, 249, 244, 1),
        0 0 0 0.5px inset rgba(255, 255, 255, 1),
        0 0 4px 2px inset rgba(253, 253, 251, 1)`,
    borderRadius: "8px",
    backgroundColor: selected
      ? "rgba(211, 209, 199, 1)"
      : "rgba(252, 251, 248, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
);

type FontOptionProps = {
  updateFont: (Font: string | undefined) => void;
  FontLabel?: keyof typeof fontMap;
  selected?: boolean;
};

export const FontOption = ({
  FontLabel,
  updateFont,
  selected,
}: FontOptionProps) => {
  return (
    <StyledFontOption
      onClick={() => {
        updateFont(FontLabel);
      }}
      css={css`
        font-family: ${FontLabel ? fontMap[FontLabel].fontFamily : "inherit"};
      `}
      title={FontLabel ? fontMap[FontLabel].displayName : "Literata"}
      selected={selected}
    >
      <FlexColContainer
        style={{ alignItems: "center", justifyContent: "center" }}
      >
        <div style={{ fontSize: "20px" }}>Aa</div>
        <div
          style={{
            fontSize: "10px",
            textAlign: "center",
          }}
        >
          {FontLabel ? fontMap[FontLabel].displayName : "Literata"}
        </div>
      </FlexColContainer>
    </StyledFontOption>
  );
};
